var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 199,
    viewBox: "0 0 140 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8368 120.594L39.0492 99.9174L34.2373 71.6073L39.3273 34.3276L41.3791 14.1006L60.636 14.1288L80.8823 43.6629L97.6909 61.0399L95.0276 72.2804L100.589 84.3142L101.73 104.637L134.26 152.506L138.913 169.147L129.18 166.292L122.048 164.93L113.769 168.428L104.442 179.406L84.2818 175.809L77.5149 189.97L68.2292 177.498L55.4844 189.43L50.8682 186.238L46.9068 188.848L49.1725 176.465L45.1222 162.405L43.8368 120.594Z",
    fill: "#0A2356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.446 147.083L117.52 152.125L115.068 159.657L108.473 160.451L104.179 153.938L111.446 147.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.709 135.24L107.66 141.954L98.7596 151.158L92.3606 146.914L86.9734 134.629L96.1055 125.912L104.709 135.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.712 135.842L109.447 140.147L107.337 132.823L109.544 124.438L116.283 128.583L116.712 135.842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.32 148.4L123.907 143.493L118.722 142.187L115.312 144.458L120.765 152.481L125.32 148.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.358 162.742L101.481 156.76L92.1619 152.642L87.9195 159.731L90.1764 167.566L101.531 174.257L107.302 167.981L104.358 162.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8465 146.37L82.4879 152.944L78.651 151.534L77.4983 147.533L81.2339 141.964L85.0024 143.822L87.8465 146.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0731 133.646L86.3134 137.952L79.3156 135.305L77.4939 128.982L82.8535 125.941L85.0731 133.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5566 125.912L76.7821 132.399L75.8503 137.345L71.0985 138.714L63.6958 133.858L65.4763 122.175L72.5566 125.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5935 151.721L74.5114 147.965L71.2023 148.005L67.2908 152.291L70.5674 157.711L76.3286 157.619L75.5935 151.721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1553 161.463L80.3283 157.354L78.9177 163.26L82.3153 167.637L86.1973 167.886L85.1553 161.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.821 119.325L102.355 122.721L98.9367 118.456L94.339 119.78L93.2952 116.157L99.3839 112.407L106.428 113.62L105.821 119.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1339 120.367L91.9248 111.401L86.2071 108.389L83.2856 114.136L78.4432 113.728L80.0966 119.467L85.7642 122.739L91.1339 120.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1205 120.328L73.6736 121.609L72.523 117.615L65.1115 115.337L67.184 111.729L78.1205 120.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8233 97.1236L72.3789 103.255L62.3724 97.8841L61.3941 94.488L57.1609 95.7075L56.8928 89.6523L65.6878 85.4028L71.0419 87.7846L71.8233 97.1236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7446 103.587L76.1207 108.931L74.8965 104.681L77.3984 103.275L76.501 100.647L78.5576 95.9296L84.1603 98.9898L82.7446 103.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7475 106.007L93.8019 109.523L93.2791 105.666L87.8028 102.425L88.0422 97.921L93.2321 96.4259L97.6825 99.3067L98.7475 106.007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5643 139.956L61.0242 135.15L57.979 136.027L54.1396 132.83L50.6046 135.538L48.946 140.781L54.8473 146.301L59.4169 144.984L64.5643 139.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.799 148.49L68.6719 144.966L65.4479 145.895L61.2983 149.749L57.3655 150.628L58.5685 154.804L63.7756 157.031L65.0538 151.337L68.799 148.49Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4127 171.923L78.7906 167.932L74.1928 165.897L69.2872 166.034L64.6612 172.003L67.9315 174.542L71.8823 170.642L74.977 173.02L81.4127 171.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.79 165.788L63.183 169.069L60.4198 167.843L59.7125 165.388L53.8848 164.972L55.2527 160.472L61.2625 160.203L65.79 165.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8065 163.26L70.3199 161.57L68.5962 160.211L67.8397 161.576L64.2333 161.468L66.1534 164.339L69.8506 164.565L70.8065 163.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0076 121.833L60.0282 128.729L57.1627 129.862L53.5975 127.392L49.5988 127.503L49.8497 118.177L56.1751 113.707L61.2492 114.893L62.0076 121.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7215 107.908L62.13 111.757L59.9907 109.271L55.6142 109.229L53.9189 106.282L57.2731 104.474L61.6302 104.897L62.916 101.641L64.7215 107.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8121 150.814L56.6234 154.217L52.9887 154.813L50.19 152.146L45.0246 153.634L45.3342 147.041L49.2765 145.905L54.8121 150.814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4526 169.981L57.1652 166.651L53.7102 166.923L49.6721 169.768L52.3311 173.373L57.8017 172.945L59.4526 169.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.71 129.1L48.8787 133.157L46.9682 133.915L46.4564 132.139L47.71 129.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0164 114.565L49.8173 112.504L51.4711 110.38L49.5882 107.888L46.8584 108.674L45.2229 110.335L44.0164 114.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9065 102.024L49.9709 97.5966L47.0794 96.3728L40.9142 97.1565L41.9832 100.867L44.8475 101.417L46.8905 104.135L51.9065 102.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0585 82.863L54.8152 92.5578L51.57 94.8487L47.146 92.468L40.2876 92.6104L41.8238 84.5847L47.2966 83.6369L50.752 80.6529L55.0585 82.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1852 75.2459L39.7391 81.2989L37.0641 75.9787L39.2188 72.0891L42.1852 75.2459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5543 21.909L58.1082 27.962L55.4333 22.6418L57.588 18.7522L60.5543 21.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1237 81.8286L90.3426 92.535L86.2245 91.6115L84.3658 93.3401L80.5383 91.0148L85.0043 82.2247L87.0255 85.3544L94.1237 81.8286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2896 77.9539L78.4485 86.3443L69.2887 81.6991L64.5427 75.79L69.5241 70.3437L76.3272 71.8005L82.2896 77.9539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3616 66.3391L79.9193 69.7242L76.9532 67.6091L78.703 65.3967L81.3616 66.3391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6312 16.6692L53.1898 20.0578L50.2228 17.9391L51.9726 15.7268L54.6312 16.6692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0677 26.9358L62.6254 30.3209L59.6593 28.2057L61.4091 25.9934L64.0677 26.9358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4689 68.6896L61.0259 74.4239L62.646 80.048L59.4851 80.9585L53.8763 76.3358L55.5766 68.4182L65.4689 68.6896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.418 58.791L50.7488 73.4497L48.0449 72.3499L44.9576 78.3111L43.0954 68.7115L48.4918 66.1418L53.418 58.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4433 57.4735L46.1716 61.4574L38.823 63.5743L36.4755 55.425L39.7634 51.1484L48.4433 57.4735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4957 66.2207L38.9193 72.3152L35.0868 69.3663L36.5073 65.4837L42.4957 66.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5572 30.8689L49.1076 36.9229L46.4362 31.6018L48.5909 27.7122L51.5572 30.8689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8629 21.8412L48.2864 27.9357L44.4585 24.9893L45.879 21.1067L51.8629 21.8412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6632 58.3174L73.1212 65.2694L69.8005 64.3208L63.0059 63.407L60.2734 53.9217L66.7542 50.176L76.6632 58.3174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3057 45.2313L56.608 48.2435L49.2101 44.1816L49.5567 37.8887L56.4835 34.8744L61.7326 40.0666L60.3057 45.2313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0711 50.4965L51.5255 48.0824L49.8027 49.6506L50.9503 53.6343L54.0837 53.1028L54.6993 55.2398L55.0711 50.4965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.366 30.3051L54.8204 27.8909L53.0976 29.4592L54.2442 33.4394L57.3776 32.9079L57.9943 35.0484L58.366 30.3051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2675 42.4905L44.4622 41.1246L42.8143 44.6258L40.142 46.6266L38.8332 42.0833L41.7054 36.2447L47.6166 36.6213L48.2675 42.4905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2476 32.2766L67.2266 34.5025L65.5509 37.0117L63.9484 36.2574L61.5996 34.8357L63.2642 32.9205L65.9205 32.1554L67.1124 31.2211L68.2476 32.2766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1646 15.5364L47.1446 17.7658L45.4689 20.2749L43.8664 19.5207L41.5201 18.0944L43.1822 16.1838L45.8385 15.4186L47.0294 14.4808L48.1646 15.5364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.213 158.442L125.309 156.619L124.117 159.622L125.612 160.967L128.213 158.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8722 176.549L62.2159 181.708L57.2565 183.871L55.3402 186.81L50.8232 183.921L52.117 175.621L56.5289 174.35L59.3837 171.876L61.8722 176.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7985 178.142L75.2588 181.071L73.7538 176.914L77.0696 175.224L78.7985 178.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1205 70.0947L92.1123 73.5178L93.2227 75.6335L87.6639 82.0529L86.7033 75.504L83.6613 72.6115L88.4516 67.2658L94.1205 70.0947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9772 60.7082L93.4601 65.8232L86.2326 62.1288L88.4159 55.2425L94.9772 60.7082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7524 46.4318L84.6751 54.1271L73.6173 47.8469L79.7524 46.4318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4549 34.5333L41.1587 25.403L47.4508 36.4423L41.4549 34.5333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7939 34.9892L74.1242 44.3103L66.1381 48.232L65.55 42.7387L69.514 40.1764L70.1721 34.7937L72.7939 34.9892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6162 85.7578L98.0461 95.4443L94.1077 92.0487L97.6162 85.7578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0532 17.2433L66.8624 25.6645L61.8038 24.44L62.0532 17.2433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 179,
    fill: "white",
    transform: "matrix(-0.960923 0.276817 0.276817 0.960923 90.3271 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.svg";
export { ForwardRef as ReactComponent };